import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { candidateRedirect } from "./candidate.guard";

/**
 * Telas exclusivas do aluno (spec 012 RF1). É o espelho do `teacherGuard`:
 * professora e gerente não têm plano para gerenciar, então caem no painel
 * delas em vez de ver uma tela vazia.
 */
export const studentGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!authService.isLoggedIn()) {
    router.navigate(["/login"]);
    return false;
  }

  const candidate = candidateRedirect();
  if (candidate) return candidate;

  if (authService.isStudent()) {
    return true;
  }

  router.navigate(["/teacher-dashboard"]);
  return false;
};
